import React, { useEffect, useState } from "react";
import { Link, useHistory } from "react-router-dom";
import { Form, Input, Button, Select, Checkbox } from "antd";
import { REGISTER_USER, REGISTER_NON_BEAMER_USER } from "reducers/authReducer";
import { useDispatch, useSelector } from "react-redux";
import { RESET_REGISTRATION_SUCCESS } from "actions/Auth/actionTypes";
import { RootState } from "reducers/rootReducer";
import "./index.scss";
import 'react-phone-number-input/style.css'
import PhoneInput from "react-phone-number-input";

interface RegisterUserValues {
  email?: string;
  pin?: string;
  phone?: string;
  firstname?: string;
  lastname?: string;
}

function Register() {
  const dispatch = useDispatch();
  const history = useHistory();
  const [error, setError] = useState<string>("");
  const [registerForm] = Form.useForm();
  const { registrationSuccess, registeredEmail, isLoading } = useSelector(
    (state: RootState) => state.auth
  );
  const { Option } = Select;
  const [checked, setChecked] = useState<boolean>(false);

  useEffect(() => {
    if (registrationSuccess && registeredEmail) {
      dispatch({ type: RESET_REGISTRATION_SUCCESS });
      history.push("/auth/pin/verify");
    }
  }, [registrationSuccess]);

  const onSubmitHandler = (values: RegisterUserValues) => {
    const { email, pin, phone, firstname, lastname } = values;
    setError("");
    if (!email) {
      setError("Please enter email to complete registeration");
      return;
    }
    if (!phone) {
      setError("Please enter phone number to complete registeration");
      return;
    }

    const payload: RegisterUserPayload = {
      email: email?.toLowerCase(),
      password: pin,
      phoneNumber: phone,
      firstName: firstname,
      lastName: lastname,
    };

    const type = localStorage.getItem("TYPE");
    const connection = localStorage.getItem("CID");

    if (type === "nonBeamer" && connection) {
      dispatch(REGISTER_NON_BEAMER_USER(payload));
    } else {
      dispatch(REGISTER_USER(payload));
    }
  };


  return (
    <div className="page-container auth-page">
      <Form
        className="auth-form"
        name="register-form"
        id="register-form"
        layout="vertical"
        form={registerForm}
        onFinish={onSubmitHandler}
        requiredMark={false}
      >
        <h3>Sign up</h3>
        <p>Please enter your data here</p>
        <Form.Item
          name="email"
          rules={[
            {
              type: "email",
              message: "The input is not valid Email!",
            },
          ]}
        >
          <Input type="email" placeholder="Email" />
        </Form.Item>
        <Form.Item name="phone">
          <PhoneInput
            placeholder="Phone number"
            onChange={(phone) => {}}
          />
        </Form.Item>
        <Form.Item name="firstname">
          <Input type="text" placeholder="First name" />
        </Form.Item>
        <Form.Item name="lastname">
          <Input type="text" placeholder="Last name" />
        </Form.Item>
        <Form.Item name="organization">
          <Input type="text" placeholder="Organization" />
        </Form.Item>
        <Form.Item
          name="pin"
          hasFeedback
          rules={[{ required: true, message: "**Required Field" }]}
        >
          <Input type="password" placeholder="5-Digit Security PIN" />
        </Form.Item>
        <Form.Item
          name="confirm-pin"
          dependencies={["pin"]}
          hasFeedback
          rules={[
            {
              required: true,
              message: "Please confirm your pin!",
            },
            ({ getFieldValue }) => ({
              validator(_, value) {
                if (!value || getFieldValue("pin") === value) {
                  return Promise.resolve();
                }
                return Promise.reject(
                  new Error("The two pins that you entered do not match!")
                );
              },
            }),
          ]}
        >
          <Input
            type="password"
            style={{ width: "100%" }}
            placeholder="Confirm PIN"
          />
        </Form.Item>

        <Form.Item className="mb-0">
          <Checkbox
            onChange={(e: any) => {
              setChecked(e.target.checked);
            }}
            className="w-100"
          >
            <p className="option-text">
              I accept the <Link to="/privacy-policy">Terms & conditions</Link>
            </p>
          </Checkbox>
        </Form.Item>

        {error && (
          <Form.Item>
            <p className="error">{error}</p>
          </Form.Item>
        )}
        <Form.Item>
          <Button
            loading={isLoading}
            type="primary"
            disabled={!checked}
            htmlType="submit"
            onClick={() => setError("")}
          >
            Register
          </Button>
        </Form.Item>
        <Form.Item className="mb-0">
          <p className="option-text">
            Already have an account? <Link to="/auth/login">Login</Link>
          </p>
          <p className="option-text">
            Didn't get verification code?{" "}
            <Link to="/auth/pin/resend">Resend</Link>
          </p>
        </Form.Item>
      </Form>
    </div>
  );
}

export default Register;
